// @ts-check
import axiosAPI from "@/axios-auth";
import type {
  eventType,
  fileDataType,
  mapControllerType,
  staInfoType,
  waveformType,
} from "@/components/statics/types";
import { print } from "graphql";
import { defineStore } from "pinia";
import { ref } from "vue";
import { queryEventFiles, queryWaveforms } from "./schema/query";

// let axiosAPI = null;
export const useDataFileStore = defineStore("dataFileStore", {
  //==state
  state() {
    const searchListIdx = ref(0);
    const eventTarget = ref<eventType[]>([]);
    const stationTarget = ref<staInfoType[]>([]);
    const waveforms = ref<waveformType[]>([]);
    const fileData = ref<fileDataType[]>([]);
    const searchFilter = ref<mapControllerType["icons"]["criteria"][]>([]); //==返回上一頁的篩選條件
    //==action
    const getDataFile = (userLog) => {
      let station = stationTarget.value.map((d) => d.station),
        event = eventTarget.value.map((d) => d.date);
      let params = { station, event, userLog };
      // console.debug(params);

      axiosAPI
        .post("download/", params, { responseType: "blob" })
        .then((response) => {
          console.log(response);
          // create file link in browser's memory
          const href = URL.createObjectURL(response.data);
          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          Object.assign(link, {
            href,
            download: `${event.length === 1 ? event[0] : station[0]}${
              station.length === 0 ? ".tar.gz" : ".zip"
            }`,
          });
          // link.href = href;
          // link.setAttribute("download", "file.tgz"); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);

          console.log("Download Success!");
        })
        .catch((err) => {
          console.log(err);
        });
    };
    const getWaveform = async (
      event: string | Date = eventTarget[0].date,
      station: string[] = null
    ) => {
      const getStaList = () => {
        return new Promise<string[]>(async (r) => {
          let base64 = (await getEventFiles(event, 0))[0].data;
          fileData.value.length = 0;
          let staList = window.atob(base64).trim().split(/\n/);
          r(staList);
        });
      };

      if (!station) {
        station =
          //==選擇超過80或全選時
          stationTarget.value.length > 80 || !stationTarget.value.length
            ? await getStaList()
            : // .slice(0, 10)
              stationTarget.value.map((d) => d.station);
        // console.debug(station, stationTarget.value);
      }

      let params = { station, event: [event] };
      // console.debug(params);
      // console.log("[wave] params:", params);
      // console.time("[wave] fetch");

      axiosAPI
        .post("graphql/", {
          query: print(queryWaveforms),
          variables: params,
        })
        .then((response) => {
          // DEBUG: 檢查 GraphQL 結構與資料量
          const root = response?.data;
          const gqlErr = root?.errors;
          // if (gqlErr?.length) {
          //   console.warn("[wave] GraphQL errors:", gqlErr);
          // }

          const arr = response?.data?.data?.waveforms ?? [];
          // console.log('[wave] count:', arr.length, 'sample keys:', arr[0] && Object.keys(arr[0]));

          const first = arr[0];
          // console.log('[wave] raw first:', first);
          // console.log('[wave] staCode:', first?.staCode, 'event:', first?.event);

          // 關鍵：看看 waveform 到底是什麼
          // const wf = first?.waveform;
          // console.log('[wave] wf typeof:', typeof wf, 'isArray:', Array.isArray(wf));
          // if (wf && typeof wf === 'object') console.log('[wave] wf keys:', Object.keys(wf));
          // 嘗試抽樣幾個數（不一定會有）
          // console.log('[wave] wf sample:',
          //   wf?.slice?.(0,10) ??
          //   wf?.y?.slice?.(0,10) ??
          //   wf?.data?.slice?.(0,10) ??
          //   null
          // );

          let tmp = response.data.data.waveforms;
          waveforms.value = tmp;
          // console.debug(waveforms);
        })      
    //     .catch((err) => {
	  // console.log(
	  //   err,
	  //   "[wave] error:",
    //         err?.response?.status,
    //         err?.response?.data ?? err?.message
    //       );
    //     });
    };
    const getEventFiles = (event: string | Date, type: number) => {
      let fileType = [
        "staList",
        "contour",
        "polar",
        "scatter1",
        "gif1",
        "gif2",
        "gif3",
        "scatter2",
        "pgaPlot",
      ][type];
      let params = { event, fileType };
      // console.debug(params);

      return new Promise((resolve, reject) => {
        axiosAPI
          .post("graphql/", {
            query: print(queryEventFiles),
            variables: params,
          })
          .then((response) => {
            let tmp = response.data.data.eventFiles;

            fileData.value = tmp.map((file) =>
              Object.assign(file, {
                data:
                  (type
                    ? `data:image/${
                        type === 1 ? "png" : type >= 4 ? "gif" : "jpg"
                      };base64,`
                    : "") + file.data,
              })
            );
            resolve(fileData.value);
            // console.debug(fileData);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    };

    const resetState = () => {
      eventTarget.value.length = 0;
      stationTarget.value.length = 0;
      searchListIdx.value = 0;
      console.debug("clean state");
    };
    const resetFileState = () => {
      waveforms.value.length = 0;
      fileData.value.length = 0;
      // console.debug("clean state");
    };
    const resetSearchState = () => {
      Object.assign(
        searchFilter,
        ref<mapControllerType["icons"]["criteria"][]>([])
      );
      // console.debug("clean state");
    };

    return {
      getDataFile,
      getWaveform,
      getEventFiles,
      waveforms,
      eventTarget,
      stationTarget,
      searchListIdx,
      fileData,
      searchFilter,
      resetState,
      resetFileState,
      resetSearchState,
    };
  },
  persist: {
    enabled: true,
    strategies: [
      {
        storage: localStorage,
        paths: ["eventTarget", "stationTarget", "searchListIdx"],
      },
    ],
  },
});
